import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const themeSelector = createSelector(menusSelector, (menus) => menus.theme);

export default themeSelector;
